import { useMemo, useRef } from "react";
import styles from "./security.module.scss";

export function LineNumberedTextarea({
  value,
  errorLines,
  onChange,
}: {
  value: string;
  errorLines: number[];
  onChange: (next: string) => void;
}) {
  const gutterRef = useRef<HTMLPreElement>(null);
  const highlightRef = useRef<HTMLDivElement>(null);
  const errors = useMemo(() => new Set(errorLines), [errorLines]);
  const count = Math.max(value.split(/\r?\n/).length, 11);

  const syncScroll = (top: number) => {
    if (gutterRef.current) gutterRef.current.scrollTop = top;
    if (highlightRef.current) highlightRef.current.scrollTop = top;
  };

  return (
    <div
      className={`${styles.lineEditor} ${errorLines.length ? styles.lineEditorError : ""}`}
    >
      <pre ref={gutterRef} className={styles.gutter} aria-hidden>
        {Array.from({ length: count }, (_, i) => (
          <div
            key={i}
            className={`${styles.gutterLine} ${errors.has(i) ? styles.gutterLineError : ""}`}
          >
            {i + 1}
          </div>
        ))}
      </pre>
      <div className={styles.body}>
        <div ref={highlightRef} className={styles.highlights} aria-hidden>
          {Array.from({ length: count }, (_, i) => (
            <div
              key={i}
              className={`${styles.highlightLine} ${errors.has(i) ? styles.highlightError : ""}`}
            />
          ))}
        </div>
        <textarea
          value={value}
          spellCheck={false}
          className={styles.textarea}
          onScroll={(e) => syncScroll(e.currentTarget.scrollTop)}
          onChange={(e) => onChange(e.target.value)}
        />
      </div>
    </div>
  );
}
